<template>
  <main class="main" style="background-color: white;min-height: calc(100vh - 60px);overflow: hidden;">
    <portal to="headerTitle">
      Connect.S Bookings
    </portal>
    <template v-if="iframe !== null">
      <hm-col cols="12">
        <iframe :src="iframe"
                style="border: none!important;width:100%;height: calc(100vh - 60px - 60px)"
                referrerpolicy="no-referrer"
                allow="clipboard-write;"
                @load="showSpinner = false;"/>
      </hm-col>
    </template>
    <spinner-overlay v-if="showSpinner" />
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isNil } from 'lodash';
import HmCardInner from '../../../lib/layout/HmCardInner';
import TimerMixin from '../../../../mixins/TimerMixin';

export default {
  name: 'PageChannelManagerSuBookings',
  components: { HmCardInner },
  mixins: [HotelmeisterMixin, TimerMixin],

  data() {
    return {
      iframe: null,
      showSpinner: true,
    };
  },

  computed: {
    suLang: function () {
      switch (this.$shortLocale) {
        case 'de':
        case 'en':
        case 'fr':
        case 'es':
          return this.$shortLocale;
        default:
          return 'en';
      }
    },
  },

  watch: {
    iframe: function (newVal) {
      if (isNil(newVal)) this.showSpinner = true;
      else this.setTimeout(() => { this.showSpinner = false; }, 2500);
    },
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.channelManagerSu.bookingIframe(this))
        .then((response) => {
          this.iframe = `${response.data.data}&lang=${this.suLang}`;
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageChannelManagerSuBookings.vue